import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import loginImage from "../assets/image/login_image.png";
import eyeHide from "../assets/image/eye-hide-svgrepo-com.svg";
import eyeShow from "../assets/image/eye-show-svgrepo-com.svg";
import { loginUser } from "../services/userServices.js";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../assets/css/Login.css";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("Username and password are required");
      return;
    }

    try {
      const response = await loginUser(username, password);
      if (response.respObj?.token) {
        localStorage.setItem("token", response.respObj.token);
        Swal.fire({
          title: "Login Successful!",
          text: "Welcome back!",
          icon: "success",
          toast: true,
          position: "top-right",
          timer: 3000,
          showConfirmButton: false,
        });
        navigate("/home");
      } else {
        setError("Invalid credentials");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div class="login-container">
      <div class="login-card">
        <div class="login-image-container">
          <img src={loginImage} alt="Login Illustration" class="login-image" />
        </div>
        <div class="login-form-container">
          <div class="login-form">
            <h2 class="login-title">Login</h2>
            {error && <div class="alert">{error}</div>}
            <form onSubmit={handleLogin}>
              <div class="form-group">
                <label class="form-label">Username</label>
                <input
                  type="text"
                  class="form-control"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div class="form-group">
                <label class="form-label">Password</label>
                <div className="pw-input">
                  <input
                    type={showPassword ? "text" : "password"}
                    class="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <span
                    class="input-group-text"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <img
                      src={showPassword ? eyeHide : eyeShow}
                      alt="Toggle Password Visibility"
                    />
                  </span>
                </div>
              </div>
              <button type="submit" class="btn-primary-cus">
                Login now
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
